import { useTranslation } from 'react-i18next'

import ItemActions from 'js/components/Item/ItemActions/ItemActions'
import getUrls from 'js/magazine-issue/lib/getUrls'
import refetchQueries from 'js/magazine-issue/lib/refetchQueries'

type ActionsButtonEntity = {
    guid: string
    canEdit?: boolean
    url?: string
}

type ActionsButtonProps = {
    entity: ActionsButtonEntity
    smallButton?: boolean
} & Record<string, unknown>

const ActionsButton = ({
    entity,
    smallButton,
    ...rest
}: ActionsButtonProps) => {
    const { t } = useTranslation()

    const { guid, canEdit } = entity

    const urls = getUrls(guid) as {
        edit?: string
        addArticle?: string
        list?: string
    }

    return (
        <ItemActions
            entity={entity as any}
            smallButton={smallButton}
            onEdit={urls.edit}
            onAfterArchive={urls.list}
            onAfterDelete={urls.list}
            refetchQueries={refetchQueries}
            customOptions={[
                [
                    ...(canEdit
                        ? [
                              {
                                  label: t('entity-magazine.create-article'),
                                  url: urls.addArticle,
                              },
                          ]
                        : []),
                ],
            ]}
            hasCustomTheme={true}
            {...rest}
        />
    )
}

export default ActionsButton
